import Vue from 'vue';
// import {request, setAuthInHeader} from "@/api/request";
// import {req} from "vuelidate/src/validators/common";


Vue.prototype.$api = {
    $auth: { // 계정 로그인 / 회원가입 api
    },
    $handler: {
        // authHeader : setAuthInHeader
    }
};

export default Vue.prototype.$api;
